import { createSelector } from 'reselect'

const sliceName = 'leftNavigation'
const rootSelector = (state) => state[sliceName]

export const leftNavigationSelector = createSelector(
  rootSelector,
  ({ fixed, open }) => ({ fixed, open })
)
